module.exports = __webpack_public_path__ + "static/media/2.d9e22f85.jpg";